import { createReducer, on } from '@ngrx/store';
import { initialState } from './api-error.state';
import { changeErrorResponse } from './api-error.actions';

export const apiErrorReducer = createReducer(
  initialState,
  on(changeErrorResponse, (state, { errorResponse }) => ({
    ...state,
    errorResponse: errorResponse,
  }))
);
